import React from 'react'
import styled, { css } from 'styled-components'
import { bool } from 'prop-types'
import ScrollAnimation from 'react-animate-on-scroll'

import { white } from 'styles/colors'
import { H1 } from 'styles/typography'
import { media } from 'styles/media'
import { navHeight, navHeightMobile } from 'styles/global'
import * as spacing from 'styles/spacing'

import Wrapper from 'components/Wrapper'
import Header from 'components/Header'
import Button from 'components/button/Button'

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: center;
  background-image: url('${process.env.BASE_PATH}/images/home/cymatics-bg-mobile.jpg');
  background-size: cover;
  background-position: center;
  background-color: #333;
  padding-top: 2rem;
  padding-bottom: 6rem;

  ${media.small`
    padding-top: 3rem;
    padding-bottom: 7rem;
    background-image: url('${process.env.BASE_PATH}/images/home/cymatics-bg-small.jpg');
  `};

  ${media.medium`
    padding-top: 4rem;
    padding-bottom: 6rem;
    background-image: url('${process.env.BASE_PATH}/images/home/cymatics-bg.jpg');
  `};

  ${props =>
    props.hasHeader &&
    css`
      padding-top: 7rem;

      ${media.small`
        padding-top: 8rem;
      `};

      ${media.medium`
        padding-top: 9rem;
      `};
    `}
`

const HeaderWrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${navHeightMobile};

  ${media.medium`
    height: ${navHeight};
  `};
`

const Inner = styled.div`
  position: relative;
  flex: 1;
`

const Heading = styled(H1)`
  text-transform: uppercase;
  font-family: 'Trim Poster';
  color: ${white};
  font-size: 64px;
  line-height: 0.9;
  margin-bottom: ${spacing.medium} !important;

  ${media.small`
    font-size: 80px;
  `};

  ${media.medium`
    font-size: 94px;
    margin-bottom: ${spacing.large} !important;
  `};

  ${media.large`
    font-size: 106px;
  `};

  ${media.xLarge`
    font-size: 120px;
  `};
`

const Subheading = styled.p`
  color: ${white};
  margin-left: auto;
  margin-right: auto;
  max-width: 330px;
  font-size: 16px;

  ${media.small`
    font-size: 20px;
    max-width: 700px;
  `};

  ${media.medium`
    font-size: 22px;
    max-width: 800px;
  `};

  ${media.large`
    font-size: 26px;
    max-width: 960px;
  `};

  ${media.xLarge`
    font-size: 30px;
    max-width: 1060px;
  `};
`

const Spacer = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;

  ${media.large`
    max-width: 480px;
  `};

  ${media.xLarge`
    max-width: 540px;
  `};

  &:after {
    content: '';
    display: block;
    padding-bottom: 100%;
    width: 100%;
  }
`
const StyledButton = styled(Button)`
  min-width: 200px;

  ${media.small`
    min-width: 240px;
  `};

  ${media.medium`
    min-width: 280px;
  `};

  ${media.large`
    min-width: 310px;
  `};
`

const Cymatics = ({ hideHeader }) => (
  <Container hasHeader={!hideHeader}>
    {!hideHeader && (
      <HeaderWrap>
        <Header transparent />
      </HeaderWrap>
    )}
    <Inner>
      <Wrapper>
        <ScrollAnimation animateIn="fadeInUp" delay={0} offset={0} animateOnce>
          <Heading>Dropping now</Heading>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={200} offset={0} animateOnce>
          <Subheading>
            DISCOVER THE LATEST DESIGNS FROM THE LIMITED EDITION FREQUENCY COLLECTION FOR <strong>ePod</strong>.
          </Subheading>
        </ScrollAnimation>
        <Spacer />

        <ScrollAnimation animateIn="fadeInUp" delay={400} offset={0} animateOnce>
          <StyledButton
            href="https://ca-frequency.vuse.com/"
            size="large"
            theme="custom"
            customColor={white}
            variant="outline"
            target="_blank"
          >
            Discover now
          </StyledButton>
        </ScrollAnimation>
      </Wrapper>
    </Inner>
  </Container>
)

Cymatics.propTypes = {
  hideHeader: bool
}

export default Cymatics
